
































import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  IInternationalization,
  IInternationalizationStatus
} from '@/models/internationalization';
import { getAvailableFlagPaths } from '@/utils/getAvailableFlagPaths';

import { Typography, Picture } from '@/components/atoms';
import CheckIcon from '@/components/icons/Check.vue';

type TagInfo = {
  bg: string;
  label: string;
};

@Component({
  components: {
    Typography,
    Picture,
    CheckIcon
  }
})
export default class PhoneInputCountryItem extends Vue {
  @Prop({ required: true }) readonly country?: IInternationalization;
  @Prop() readonly selectedCountry?: IInternationalization;

  availableCountryFlags = getAvailableFlagPaths();

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get isSelected() {
    return (
      this.selectedCountry &&
      this.country &&
      this.selectedCountry.countryIso2 === this.country.countryIso2
    );
  }

  get hasCountry() {
    return !!Object.keys(this.country || {}).length;
  }

  get hasCountryFlag() {
    if (!this.country) return false;

    const country = this.getCountryName(this.country.name);

    return this.availableCountryFlags.includes(country);
  }

  getCountryName(countryName: string) {
    if (typeof countryName !== 'string') return '';

    const normalizedCountryName = countryName
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return normalizedCountryName.toLowerCase().replace(/[^A-Z0-9]+/gi, '');
  }
}
